import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import './AccountStatementModal.css';
import { CommonModal, CrossButton } from 'components';

const AccountStatementModal = (props) => {
  const { closeModal, onDownload } = props;
  const [selectedAccount, setSelectedAccount] = useState('10230534253');
  const [selectedPeriod, setSelectedPeriod] = useState('previous-day');
  const [selectedFormat, setSelectedFormat] = useState('excel');

  const handleDownload = () => {
    const downloadData = {
      account: selectedAccount,
      period: selectedPeriod,
      format: selectedFormat
    };

    if (onDownload) {
      onDownload(downloadData);
    }
    closeModal();
  };

  const propsModalInhance = {
    ...props,
    title: 'Download Account Statement',
    onSubmit: handleDownload,
    modalMainClass: "addbalance",
    onClose: closeModal,
  }

  return (
    <CommonModal {...propsModalInhance}>
      <div className='addLr_body'>
        <div className="acst-modal-body">
          {/* Account Selection */}
          <div className="acst-form-group">
            <label className="acst-form-label">SELECTED ACCOUNT</label>
            <div className="acst-select-wrapper">
              <select
                className="acst-form-select"
                value={selectedAccount}
                onChange={(e) => setSelectedAccount(e.target.value)}
              >
                <option value="10230534253">10230534253</option>
                <option value="10230534254">10230534254</option>
                <option value="10230534255">10230534255</option>
              </select>
            </div>
            <p className="acst-account-name">FRESHTIO SOLUTIONS PRIVATE LIMITED</p>
          </div>

          {/* Period Selection */}
          <div className="acst-form-group">
            <label className="acst-form-label">SELECT PERIOD</label>
            <div className="acst-radio-group">
              <label className="acst-radio-label">
                <input
                  type="radio"
                  name="period"
                  value="previous-day"
                  checked={selectedPeriod === 'previous-day'}
                  onChange={(e) => setSelectedPeriod(e.target.value)}
                />
                <span className="acst-radio-text">Previous day</span>
              </label>

              <label className="acst-radio-label">
                <input
                  type="radio"
                  name="period"
                  value="previous-7-days"
                  checked={selectedPeriod === 'previous-7-days'}
                  onChange={(e) => setSelectedPeriod(e.target.value)}
                />
                <span className="acst-radio-text">Previous 7 days</span>
              </label>

              <label className="acst-radio-label">
                <input
                  type="radio"
                  name="period"
                  value="current-month"
                  checked={selectedPeriod === 'current-month'}
                  onChange={(e) => setSelectedPeriod(e.target.value)}
                />
                <span className="acst-radio-text">Current month</span>
              </label>

              <label className="acst-radio-label">
                <input
                  type="radio"
                  name="period"
                  value="custom-period"
                  checked={selectedPeriod === 'custom-period'}
                  onChange={(e) => setSelectedPeriod(e.target.value)}
                />
                <span className="acst-radio-text">Custom period</span>
              </label>
            </div>
          </div>

          {/* File Format Selection */}
          <div className="acst-form-group">
            <label className="acst-form-label">SELECT FILE FORMAT</label>
            <div className="acst-radio-group acst-radio-inline">
              <label className="acst-radio-label">
                <input
                  type="radio"
                  name="format"
                  value="excel"
                  checked={selectedFormat === 'excel'}
                  onChange={(e) => setSelectedFormat(e.target.value)}
                />
                <span className="acst-radio-text">Excel</span>
              </label>

              <label className="acst-radio-label">
                <input
                  type="radio"
                  name="format"
                  value="pdf"
                  checked={selectedFormat === 'pdf'}
                  onChange={(e) => setSelectedFormat(e.target.value)}
                />
                <span className="acst-radio-text">PDF</span>
              </label>

              <label className="acst-radio-label">
                <input
                  type="radio"
                  name="format"
                  value="csv"
                  checked={selectedFormat === 'csv'}
                  onChange={(e) => setSelectedFormat(e.target.value)}
                />
                <span className="acst-radio-text">CSV</span>
              </label>
            </div>
          </div>

          {/* Info Text */}
          <p className="acst-info-text">
            You can only download statement for maximum 3 months up to 1 lakh transactions
          </p>
        </div>
      </div>
    </CommonModal>
  );


};

export default AccountStatementModal;